import { Typography } from "@mui/material";
import React from 'react';

const NotFound = () => (
  <div>
    <Typography variant="h4" gutterBottom>Welcome to NotFound Page</Typography>
    <Typography>This is the NotFound Page content.</Typography>
  </div>
);

export default NotFound;
